import styled from 'styled-components';

export const SelectContainer = styled.div`
  width: 100%;
`;

export const SelectStyled = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: center;
  padding: 0 16px;
  font-family: 'Poppins';
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  font-family: 'Raleway';
  line-height: 1.5rem;
  text-align: left;

  &:focus {
    outline-color: ${({ theme }) => theme.colors.black};
  }

  &.error {
    outline-color: ${({ theme }) => theme.colors.red.strong};
    border-color: ${({ theme }) => theme.colors.red.strong};
  }
`;

export const OptionStyled = styled.option`
  padding: 30px 16px;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.black};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  background: ${({ theme }) => theme.colors.white};
  font-family: 'Raleway';
  line-height: 1.5rem;

  &.placeholder {
    color: ${({ theme }) => theme.colors.disableButtonText};
  }

  &:hover {
    background-color: #e0e0e0;
  }
`;
